// @flow

import * as React from 'react'
import { Label, Button, Input, Icon } from 'semantic-ui-react'

import './editable-button.css'

type InlineInputProps = {|
  onKeyDown: (SyntheticEvent<*>) => void,
  onBlur: (SyntheticEvent<*>) => void,
  onChange: (SyntheticEvent<*>, element: React.Element<*>) => void,
  value: string,
|}
class InlineInput extends React.Component<InlineInputProps> {
  textInput: ?HTMLInputElement

  componentDidMount() {
    if (this.textInput) this.textInput.focus()
  }
  render() {
    return (
      <Input
        transparent
        className="ghost-editable-button"
        placeholder="Nome wave..."
        onKeyDown={this.props.onKeyDown}
        onBlur={this.props.onBlur}
        onChange={this.props.onChange}
        value={this.props.value}
        ref={input => {
          this.textInput = input
        }}
      />
    )
  }
}

type EditableButtonProps = {|
  onCommit: (value: string) => void,
|}
type EditableButtonState = {|
  editable: boolean,
  value: string,
|}

class EditableButton extends React.Component<EditableButtonProps, EditableButtonState> {
  static defaultProps = {
    onCommit: (value: string) => {},
  }
  state = { editable: false, value: '' }

  toggleEditing = () => {
    this.setState({ editable: !this.state.editable })
    if (!this.state.editable) {
      this.setState({ value: '' })
    }
  }

  onKeyDown = (e: SyntheticEvent<*>) => {
    if (e.keyCode === 27) {
      this.toggleEditing()
    }
    if (e.keyCode === 13) {
      this.toggleEditing()
      if (this.state.value.trim()) {
        this.props.onCommit(this.state.value)
      }
    }
  }
  onBlur = (e: SyntheticEvent<*>) => {
    this.toggleEditing()
  }
  onChange = (e: SyntheticEvent<*>, element: React.Element<*>) => {
    if (element) {
      this.setState({
        value: (element.value || '').toUpperCase().replace(' ', '_'),
      })
    }
  }

  render() {
    let elem = null
    if (!this.state.editable) {
      elem = (
        <Button size="mini" style={{ margin: '1ex' }} color="green" onClick={this.toggleEditing}>
          <Icon name="add" />
          Aggiungi Wave...
        </Button>
      )
    } else {
      elem = (
        <Label style={{ margin: '1ex' }}>
          <InlineInput
            onKeyDown={this.onKeyDown}
            onBlur={this.onBlur}
            onChange={this.onChange}
            value={this.state.value}
          />
        </Label>
      )
    }
    return elem
  }
}

export default EditableButton



// WEBPACK FOOTER //
// ./src/campaigns/editable-button.js